import OrdercallService from '../ordercall.service';
import { Settings } from "../ordercall";

class SettingsService extends OrdercallService {
    static storefronts: string[] = [];
    static domains: string[] = [];

    getStorefronts(done: (res: any) => void){
        
        if (!SettingsService.storefronts.length) {
            return this.getByAction('settings&method=storefronts').done(res => {
                SettingsService.storefronts = res.data;
                done(SettingsService.storefronts)
            });
        }

        done(SettingsService.storefronts)
    }

    getDomains(done: (res: any) => void){
        
        if (!SettingsService.domains.length) {
            return this.getByAction('settings&method=domains').done(res => {
                SettingsService.domains = res.data;
                done(SettingsService.domains)
            });
        }

        done(SettingsService.domains)
    }

    saveSettings(settings: Settings) {
        let data = {
            _csrf: this._csrf,
            settings_state: JSON.stringify(settings)
        };
        return this.postByAction('settings&method=save&eval=settings', data);
    }

    savePhoto(photo: string) {
        let data = {
            _csrf: this._csrf,
            photo
        };
        return this.postByAction('settings&method=savePhoto', data);
    }

    uploadPhoto(data: any) {
        return $.ajax({
            url: this.getActionUrl('photo&method=upload'),
            type: 'POST',
            data: data,
            cache: false,
            dataType: 'json',
            processData: false,
            contentType: false
        })
    }
    
    cropPhoto(coor: any) {
        let data = {
            _csrf: this._csrf,
            coor: coor
        };
        return this.post(this.getActionUrl('photo&method=crop'), data)
    }
}

export default SettingsService;


// WEBPACK FOOTER //
// ./src/webpack/vue/settings/settings.service.ts